"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CoinbaseWallet = void 0;
const react_1 = __importDefault(require("react"));
const connector_screen_1 = __importDefault(require("../components/connector-screen"));
const spinner_1 = __importDefault(require("../components/spinner"));
const constants_1 = require("../constants");
const use_coinbase_wallet_connector_1 = require("../hooks/use-coinbase-wallet-connector");
const use_theme_1 = __importDefault(require("../hooks/use-theme"));
const tailwind_1 = __importDefault(require("../utils/tailwind"));
const styles = (0, tailwind_1.default)({
    container: `
    tw-my-8
    tw-flex
    tw-flex-col
    tw-items-center
    tw-justify-center
    grid
    tw-gap-8
    tw-flex-grow`,
    error: `
    tw-text-md
    tw-pb-4`,
    spinnerContainer: `
    tw-relative
    tw-gap-2
    tw-items-center
    tw-flex
    tw-flex-col`,
    disclaimer: `
    tw-text-center
    tw-text-sm`,
    button: `
    tw-mt-6
    tw-px-4
    tw-py-2`,
});
const provider = constants_1.PROVIDERS['Coinbase Wallet'];
const CoinbaseWallet = ({ onSubmit }) => {
    const theme = (0, use_theme_1.default)();
    const { error } = (0, use_coinbase_wallet_connector_1.useCoinbaseWalletConnector)(onSubmit);
    let content;
    if (error) {
        content = (react_1.default.createElement("p", { className: styles.error, style: { color: theme.error } }, error.message));
    }
    else if (provider.canConnect()) {
        content = (react_1.default.createElement("div", { className: styles.spinnerContainer },
            react_1.default.createElement(spinner_1.default, null),
            react_1.default.createElement("p", { className: styles.disclaimer }, "No pop-up? Check your if your Coinbase Wallet extension is unlocked.")));
    }
    else {
        content = (react_1.default.createElement("div", null,
            react_1.default.createElement("p", { className: styles.disclaimer, style: { color: theme.textSecondary } },
                provider.name,
                " not detected.",
                react_1.default.createElement("br", null),
                "Are you sure it is installed in this browser?")));
    }
    return (react_1.default.createElement(connector_screen_1.default, { title: "Connect your Coinbase wallet", content: react_1.default.createElement("div", { className: styles.container }, content), footer: { name: 'Coinbase Wallet', url: '' } }));
};
exports.CoinbaseWallet = CoinbaseWallet;
//# sourceMappingURL=coinbase.js.map